require('../core');

angular
  .module('ui-ng-time-input')
  .controller('phxTimeInputController', function phxTimeInputController($scope) {
    $scope.flags = {
      disabled: false
    };

    $scope.models = {
      hours: 0,
      minutes: 0,
      displayHours: 0,
      displayMinutes: 0,
      displayPeriod: 'AM'
    };

    $scope.updatedModel = function updatedModel() {
      if (_.isUndefined($scope.ngModel)) {
        return;
      }

      if (_.isDate($scope.ngModel)) {
        $scope.ngModel.setHours($scope.models.hours);
        $scope.ngModel.setMinutes($scope.models.minutes);
      } else {
        $scope.ngModel.hour($scope.models.hours);
        $scope.ngModel.minutes($scope.models.minutes);
      }

      $scope.displayHours();
      $scope.displayMinutes();
      $scope.displayPeriod();
    };

    $scope.changedModel = function changedModel() {
      $scope.updatedModel();

      if (_.isFunction($scope.onChanged)) {
        $scope.onChanged({
          time: $scope.ngModel,
          formattedTime: moment($scope.ngModel).format('hh:mm a')
        });
      }
    };

    $scope.$watch('ngModel', function (v) {
      $scope.setTime(v);
    });

    $scope.increaseHours = function () {
      if ($scope.models.hours < 23) {
        $scope.models.hours = ++$scope.models.hours;
      } else {
        $scope.models.hours = 0;
      }

      $scope.changedModel();
    };

    $scope.decreaseHours = function () {
      $scope.models.hours = $scope.models.hours <= 0 ? 23 : --$scope.models.hours;

      $scope.changedModel();
    };

    $scope.increaseMinutes = function () {
      if ($scope.models.minutes >= 59) {
        $scope.models.minutes = 0;
      } else {
        $scope.models.minutes++;
      }

      $scope.changedModel();
    };

    $scope.decreaseMinutes = function () {
      if ($scope.models.minutes <= 0) {
        $scope.models.minutes = 59;
      } else {
        $scope.models.minutes = --$scope.models.minutes;
      }

      $scope.changedModel();
    };

    $scope.switchPeriod = function () {
      $scope.models.hours = $scope.models.hours >= 12 ? $scope.models.hours - 12 : $scope.models.hours + 12;

      $scope.changedModel();
    };

    $scope.displayHours = function () {
      var hoursToDisplay = $scope.models.hours;

      if ($scope.models.hours > 12) {
        hoursToDisplay = $scope.models.hours - 12;
      }

      if (hoursToDisplay == 0) {
        hoursToDisplay = 12;
      }

      $scope.models.displayHours = hoursToDisplay;
      return hoursToDisplay;
    };

    $scope.displayMinutes = function () {
      $scope.models.displayMinutes = $scope.models.minutes;
      return $scope.models.displayMinutes;
    };

    $scope.displayPeriod = function () {
      $scope.models.displayPeriod = $scope.models.hours >= 12 ? 'PM' : 'AM';
      return $scope.models.displayPeriod;
    };

    $scope.onChangeHours = function onChangeHours(hours) {
      var hours = parseInt(hours, 10);

      if (_.isNumber(hours) && !_.isNaN(hours)) {
        $scope.models.hours = hours % 12;

        if ($scope.models.displayPeriod === 'PM') {
          $scope.models.hours += 12;
        }
      }

      $scope.changedModel();
    };

    $scope.onChangeMinutes = function onChangeMinutes(minutes) {
      var minutes = parseInt(minutes, 10);

      if (_.isNumber(minutes) && !_.isNaN(minutes)) {
        $scope.models.minutes = minutes % 60;
      }

      $scope.changedModel();
    };

    $scope.onChangePeriod = function onChangePeriod(period) {
      if (!period) {
        period = $scope.displayPeriod();
      }

      period = period.toUpperCase();

      if (!(period === 'AM' || period === 'PM')) {
        period = $scope.displayPeriod();
      }

      if (period === 'AM' && $scope.models.hours >= 12) {
        $scope.models.hours -= 12;
      } else if (period === 'PM' && $scope.models.hours < 12) {
        $scope.models.hours += 12;
      }

      $scope.changedModel();
    };
  })
  .constant('phxTimeInputDelegateConstant', {
    uniqueComponent: 'ui-ng-time-input',
    vocabulary: {
      setTime: function setTime_phxTimeInput(scope, element, attrs, event, time) {
        var time = moment(time);

        scope.models.hours = time.hour();
        scope.models.minutes = time.minutes();
        scope.changedModel();
      }
    }
  })
  .directive('phxTimeInput', function phxTimeInput(DelegateResponder, phxTimeInputDelegateConstant) {
    return {
      restrict: 'E',
      replace: false,
      require: '?ngModel',
      templateUrl: 'ui-ng-time-input/src/templates/standard.html',
      controller: 'phxTimeInputController',
      scope: {
        ngModel: '=?',
        disabled: '@',
        onChanged: '&?'
      },
      compile: function phxTimeInputCompile(element, attrs) {
        element.addClass('phx-time-input');

        return DelegateResponder(phxTimeInputDelegateConstant, function (scope, element, attrs) {
          attrs.$observe('disabled', function handleDisabled(isDisabled) {
            scope.flags.isDisabled = isDisabled === 'disabled' || isDisabled === 'true' || isDisabled === '';

            if (scope.flags.isDisabled) {
              element.attr('tabindex', '-1');
            } else {
              element.attr('tabindex', '0');
            }
          });
        });
      }
    };
  })
  .service('phxTimeInputDelegate', function phxTimeInputDelegate(DelegateController, phxTimeInputDelegateConstant) {
    DelegateController(this, phxTimeInputDelegateConstant);
  });



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-time-input/src/core/component.js